// extracted by mini-css-extract-plugin
export default {"settingsNav":"settingsNav_settingsNav__+HxbB","active":"settingsNav_active__GzEWL"};